import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';

import AddressGroupV2 from 'components/field/AddressGroupV2';
import StringInput from 'components/field/StringInput';
import FormItem from 'components/form/FormItem';

import useLocale from 'hooks/useLocale';

export const BranchLocations = ({ mode, isFoodicsUser }) => {
	const defaultColSpan = {
		md: 6
	};
	const viewMode = mode === 'view';
	const { planName = null } = useSelector((state) => state.user);
	const { Country } = useLocale();
	const allowedCountriesStr = useSelector((state) => state.user.localization.allowedCountries);

	const allowedCountries = useMemo(
		() => (allowedCountriesStr ? [Country, ...allowedCountriesStr.split(',')] : [Country]),
		[allowedCountriesStr]
	);

	const formMethods = useFormContext();
	const {
		formState: { isLoading: isFormLoading, isSubmitting }
	} = formMethods;

	const isLoading = isFormLoading || isSubmitting;

	return (
		<>
			<FormItem colSpan={defaultColSpan} label="branchName" isLoading={isLoading} required>
				<StringInput disabled={viewMode} name="name" />
			</FormItem>

			<FormItem colSpan={defaultColSpan} label="branchCode" isLoading={isLoading}>
				<StringInput disabled={viewMode} name="branchCode" />
			</FormItem>

			<AddressGroupV2
				formMode={mode}
				formFieldName="address"
				disabled={isFoodicsUser || viewMode}
				isLoading={isLoading}
				restrictions={
					planName !== 'EnterprisePackage'
						? {
								country: {
									code: planName === 'FreePackage' ? Country : allowedCountries
								}
							}
						: null
				}
			/>
		</>
	);
};
